import { Box, Button, Stack } from '@mui/material';
import React, { useRef,useState,useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';

const Signature = ({ onSignatureSave, fileformBusy }) => {
  const sigCanvas = useRef({});
  const [canvasWidth, setCanvasWidth] = useState(500);
  const [canvasHeight, setCanvasHeight] = useState(200);
  const saveSignature = () => {
    const signatureImage = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
    
    onSignatureSave(signatureImage);  // Pass the signature image to the parent component
  };

  const updateCanvasSize = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 600) {
      setCanvasWidth(screenWidth - 40); // Small screens
      setCanvasHeight((screenWidth - 40) * 0.4);
    } else if (screenWidth < 1024) {
      setCanvasWidth(500); // Medium screens
      setCanvasHeight(200);
    } else {
      setCanvasWidth(1024); // Large screens
      setCanvasHeight(250);
    }
  };

  useEffect(() => {
    updateCanvasSize();
    window.addEventListener("resize", updateCanvasSize);
    return () => window.removeEventListener("resize", updateCanvasSize);
  }, []);


  return (
    <Box sx={{border:"solid 1px #000",borderRadius:2}} mb={2}  >
      <SignatureCanvas
        ref={sigCanvas}
        penColor="black"
        canvasProps={{ width: canvasWidth, height: canvasHeight, className: 'sigCanvas' }}
      />
      <Stack direction={"row"} justifyContent={"end"} spacing={2} mx={2} mb={2} >
        <Button variant="outlined" type='button' onClick={saveSignature}>{fileformBusy ? "Please wait..." : "Save"}</Button>
        <Button variant="outlined" onClick={() => { sigCanvas.current.clear(); onSignatureSave(null) }}>Clear</Button>
      </Stack>
    </Box>
  );
};

export default Signature;
